import { COMPARISON } from "../../data/content";
import Reveal from "./Reveal";

function Marker({ value }) {
  if (value === "yes") {
    return <span className="font-serif-display text-[#E5D3B3] text-xl">●</span>;
  }
  if (value === "no") {
    return <span className="text-white/15 text-xl">○</span>;
  }
  return (
    <span className="text-[10px] uppercase tracking-[0.2em] text-white/40">
      varies
    </span>
  );
}

export default function Comparison() {
  return (
    <section
      id="comparison"
      data-testid="comparison-section"
      className="relative bg-[#050B14] py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-20">
          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{COMPARISON.overline}</span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="comparison-headline"
                className="font-serif-display text-white text-[clamp(2.25rem,5vw,4.5rem)] leading-[1.05] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {COMPARISON.title}
              </h2>
            </Reveal>
          </div>
        </div>

        {/* Table — desktop */}
        <Reveal>
          <div
            data-testid="comparison-table"
            className="hidden md:block overflow-x-auto no-scrollbar border border-white/10"
          >
            <table className="w-full min-w-[900px] text-left">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="overline py-6 px-6 text-white/50 font-medium align-bottom">
                    Trait
                  </th>
                  {COMPARISON.columns.map((c, i) => (
                    <th
                      key={c}
                      className={`py-6 px-4 align-bottom ${
                        i === 0
                          ? "bg-gradient-to-b from-[#E5D3B3]/8 to-transparent"
                          : ""
                      }`}
                    >
                      <div
                        className={`font-serif-display text-base md:text-lg leading-tight ${
                          i === 0 ? "text-[#E5D3B3]" : "text-white/80"
                        }`}
                      >
                        {c}
                      </div>
                      {i === 0 && (
                        <div className="overline text-[9px] text-[#E5D3B3]/70 mt-2">
                          This yacht
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COMPARISON.rows.map((row, ri) => (
                  <tr
                    key={row.trait}
                    className="border-b border-white/5 last:border-b-0"
                  >
                    <td className="py-6 px-6 text-[#D4C9A8] text-sm md:text-base font-light">
                      {row.trait}
                    </td>
                    {row.values.map((v, vi) => (
                      <td
                        key={vi}
                        className={`py-6 px-4 ${
                          vi === 0
                            ? "bg-gradient-to-b from-[#E5D3B3]/5 to-transparent"
                            : ""
                        }`}
                      >
                        <Marker value={v} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        {/* Mobile — stacked */}
        <div className="md:hidden space-y-10">
          {COMPARISON.rows.map((row) => (
            <Reveal key={row.trait}>
              <div className="border-t border-white/10 pt-6">
                <div className="font-serif-display text-white text-xl mb-4">
                  {row.trait}
                </div>
                <div className="grid grid-cols-2 gap-y-3 gap-x-4">
                  {COMPARISON.columns.map((c, i) => (
                    <div
                      key={c}
                      className="flex items-center justify-between border-b border-white/5 pb-2"
                    >
                      <span
                        className={`text-xs uppercase tracking-[0.15em] ${
                          i === 0 ? "text-[#E5D3B3]" : "text-white/50"
                        }`}
                      >
                        {c}
                      </span>
                      <Marker value={row.values[i]} />
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
